var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGmMessages = function SvgGmMessages(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7579 23.4774C39.6582 23.8656 39.6582 24.2538 39.5584 24.642C39.1592 26.8741 38.1612 28.718 36.5645 30.2708C34.4688 32.3089 31.8741 33.2793 28.8803 33.2793C27.8823 33.2793 26.8844 33.2793 25.9862 33.2793C25.8864 33.2793 25.7866 33.2793 25.6868 33.2793C25.6868 33.3764 25.6868 33.4734 25.6868 33.4734C25.6868 34.541 25.6868 35.6085 25.6868 36.6761C25.6868 36.9672 25.587 37.1613 25.2876 37.3554C24.9883 37.4524 24.7887 37.3554 24.5891 37.2584C24.4893 37.2584 24.4893 37.1613 24.3895 37.1613C23.0922 36.0938 21.695 34.9292 20.3977 33.8616C19.1003 32.7941 17.7032 31.7266 16.4059 30.562C13.8112 28.2328 12.7135 25.4184 13.0128 22.0217C13.2124 19.4984 14.3102 17.2663 16.1065 15.5194C18.2022 13.4814 20.7969 12.4138 23.7907 12.4138C25.4872 12.4138 27.084 12.4138 28.7805 12.4138C30.976 12.4138 33.0717 12.9961 34.868 14.1607C37.3629 15.8105 38.8598 18.0427 39.4586 20.8571C39.5584 21.2453 39.5584 21.7305 39.6582 22.1187C39.7579 22.604 39.7579 22.9922 39.7579 23.4774Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5964 23.7686C21.368 23.7686 21.9935 23.1603 21.9935 22.41C21.9935 21.6596 21.368 21.0513 20.5964 21.0513C19.8247 21.0513 19.1992 21.6596 19.1992 22.41C19.1992 23.1603 19.8247 23.7686 20.5964 23.7686Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8874 23.7686C26.659 23.7686 27.2845 23.1603 27.2845 22.41C27.2845 21.6596 26.659 21.0513 25.8874 21.0513C25.1158 21.0513 24.4902 21.6596 24.4902 22.41C24.4902 23.1603 25.1158 23.7686 25.8874 23.7686Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.276 23.7686C32.0477 23.7686 32.6732 23.1603 32.6732 22.41C32.6732 21.6596 32.0477 21.0513 31.276 21.0513C30.5044 21.0513 29.8789 21.6596 29.8789 22.41C29.8789 23.1603 30.5044 23.7686 31.276 23.7686Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.9648,
    y1: 12.4138,
    x2: 40.7168,
    y2: 13.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGmMessages);
export default ForwardRef;